import { ISmartFieldChange } from "@components/smart/smartField/SmartField";
import { createPath } from "@odata/BindingContext";
import {
    IPrHozSubmissionEntity,
    PrHozSubmissionEmployeeEntity,
    PrHozSubmissionEntity
} from "@odata/GeneratedEntityTypes";
import { PrSubmissionSubtypeCode, PrSubmissionTypeCode } from "@odata/GeneratedEnums";
import { setCompanyRelation } from "@pages/payroll/submission/Submission.utils";
import { SubmissionsFormViewForExtend } from "@pages/payroll/submission/SubmissionFormView";

import { withPermissionContext } from "../../../../contexts/permissionContext/withPermissionContext";
import { FormStorage } from "../../../../views/formView/FormStorage";

class PrHozSubmissionFormView extends SubmissionsFormViewForExtend<IPrHozSubmissionEntity> {
    typeCode = PrSubmissionTypeCode.EmployersMassHealthInsuranceNotification;
    subTypeCode: PrSubmissionSubtypeCode = null;
    pathToEmployee = createPath(PrHozSubmissionEntity.Employee, PrHozSubmissionEmployeeEntity.Employee);

    async typeSpecificOnAfterLoad(isNew: boolean): Promise<void> {
        const { storage } = this.props;
        const entity = storage.getEntity();
        const promises: Promise<void>[] = [];

        if (isNew) {
            promises.push(setCompanyRelation(storage as unknown as FormStorage, { insurancePayer: true, withAddress: true, withPhoneNumber: true }));
        }

        await Promise.all(promises);
    }

    handleChange(e: ISmartFieldChange) {
        super.handleChange(e);

        const shouldUpdate = e.triggerAdditionalTasks !== false;
        this.props.storage.refreshFields(shouldUpdate);
    }

    onBeforeSave(data?: IPrHozSubmissionEntity): IPrHozSubmissionEntity {
        data = super.onBeforeSave(data);

        if (!data.Detail) {
            data.Detail = {};
        }

        return data;
    }
}

export default withPermissionContext(PrHozSubmissionFormView);